<p class="headline6">
    {{preguntasFrecuentes[0].subSeccionAyuda.nombre}}
</p>
<div *ngFor="let pregunta of preguntasFrecuentes">
    <app-pregunta-help [pregunta]="pregunta"></app-pregunta-help>
</div>